// modules
import { addModal } from 'weblite-web-modal-viewer'
import { InviteLink } from '@weblite/ts-action/hall'
// component
import { RevokedLinkMenu } from './revoked-link-menu'

const COMPONENT_ID = 'revokedLinkMenu'

interface Prop {
  link: InviteLink
}

export const showRevokedLinkMenu = (props: Prop, preventBackClick = false) =>
  addModal({ id: COMPONENT_ID, props, preventBackClick })

export default {
  [COMPONENT_ID]: { Component: RevokedLinkMenu },
}
